import { createContext } from 'react';
import { TContext } from './Select';

export const SelectContext = createContext<TContext | null>(null);